import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=dc9e0074&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9e0074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc9e0074')) {
      api.createRecord('dc9e0074', component.options)
    } else {
      api.reload('dc9e0074', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=dc9e0074&scoped=true&", function () {
      api.rerender('dc9e0074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4yzlc7JZuBXQ4/JS/comp/Accordion.vue"
export default component.exports